<script lang="ts" setup>
const { error } = defineProps<{ error?: string }>();
</script>

<template>
  <div>{{ error }}</div>
</template>

<style scoped></style>
